import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './Packages.styles';
import { BuyPackages } from '@/components/Profile/Business/BuyPackages';
import { ActivePackage } from '@/components/Profile/Business/ActivePackage';
import { Typography } from '@/components/UI/Typography/Typography.styles';

const hasActivePackage = true;

interface PackagesProps {
  id: string;
}

export const Packages = React.forwardRef<HTMLDivElement, PackagesProps>(
  ({ id }, ref) => {
    const { t } = useTranslation();

    return (
      <>
        <S.Box id={id} ref={ref}>
          <Typography.Header $variant="2">
            {t('pages.cabinet.active_package')}
          </Typography.Header>

          {hasActivePackage ? (
            <ActivePackage />
          ) : (
            <S.Text $variant="1">
              {t('pages.cabinet.you_dont_have_active_package')}
            </S.Text>
          )}
        </S.Box>

        <BuyPackages />
      </>
    );
  }
);

Packages.displayName = 'Packages';
